import React, { useEffect, useRef } from 'react';

const SlickHorizontalTimeline = ({events, isOngoing, eventCount}) => {
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (scrollContainerRef.current && events?.length > 0) {
      scrollContainerRef.current.scrollLeft = scrollContainerRef.current.scrollWidth;
    }
  }, [events]);

  // Function to get status color
  const getStatusColor = (status) => {
    const statusColors = {
      "Created": "#7caf7d",
      "Fetching Contextual Logs": "#8ec4e6",
      "Fetched Logs": "#19a8d8",
      "Sending Notification": "#ecba8c",
      "Sent Notification": "#f1e099",
      "Analyzing Metrics": "#e6b1f1",
      "Analyzed Metrics": "#c18bd5",
      "Generating Runbook": "#f37ca0",
      "Complete": "#aee4b0",
      "Generated Runbook": "#aee4b0",
      "Running Diagnostics": "#df8ca5",
      "Analyzing": "#e6b1f1",
      "Executing Diagnostics": "#3daada",
      "Executing Recovery": "#9c284b",
    };
    return statusColors[status] || "#9dcce3";
  };

  const timeFormat = (timeStr) => {
    return timeStr.replace(" PM", "").replace(" AM", "");
  };

  return (
    <div style={{
      background: "#1a1d20",
      color: "#f8f9fa",
      padding: "16px",
      borderRadius: "8px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
      fontSize: "12px",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      <div 
        ref={scrollContainerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          position: "relative",
          paddingBottom: "6px",
          scrollBehavior: "smooth"
        }}>
        {/* Timeline line */}
        <div style={{
          position: "absolute",
          height: "2px",
          backgroundColor: "#c5cacf",
          top: "15px",
          left: "0",
          right: "0",
          width: (eventCount * 100) + "px",
          marginLeft: "-16px", // Adjusts for container padding
          zIndex: 1
        }}></div>

        {/* Timeline events */}
        {events?.map((event, index) => {
          const isLatestEvent = index === events.length - 1;

          return (
            <div key={index} style={{
              flex: "0 0 auto",
              padding: "0 2px",
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              transition: "all 0.2s ease",
              minWidth: "80px",
              maxWidth: "120px"
            }}>
              {/* Timeline node - Spinning dot for latest event */}
              {isLatestEvent && isOngoing ? (
                <div style={{
                  width: "14px",
                  height: "14px",
                  backgroundColor: "orange",
                  borderRadius: "50%",
                  marginBottom: "6px",
                  marginTop: "8px",
                  position: "relative",
                  animation: "pulse 1s infinite ease-in-out"
                }}>
                  <style>
                    {`
                      @keyframes pulse {
                        0% {
                          box-shadow: 0 0 0 0 ${getStatusColor(event.status)}80;
                          transform: scale(0.5);
                        }
                        70% {
                          box-shadow: 0 0 0 6px ${getStatusColor(event.status)}00;
                          transform: scale(0.75);
                        }
                        100% {
                          box-shadow: 0 0 0 0 ${getStatusColor(event.status)}00;
                          transform: scale(0.95);
                        }
                        120% {
                          box-shadow: 0 0 0 0 ${getStatusColor(event.status)}00;
                          transform: scale(1.2);
                        }
                      }
                    `}
                  </style>
                </div>
              ) : (
                <div style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: getStatusColor(event.status),
                  borderRadius: "50%",
                  marginBottom: "6px",
                  marginTop: "8px",
                  boxShadow: `0 0 0 2px #1a1d20, 0 0 0 4px ${getStatusColor(event.status)}30`,
                  transition: "all 0.2s ease"
                }}></div>
              )}

              {/* Time */}
              <div style={{
                color: "#adb5bd",
                fontSize: "8px",
                marginBottom: "6px",
                fontWeight: "500"
              }}>
                {timeFormat(event.time)}
              </div>

              {/* Status */}
              <div style={{
                border: `1px solid ${getStatusColor(event.status)}30`,
                borderRadius: "4px",
                padding: "4px 8px",
                textAlign: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: getStatusColor(event.status),
                fontWeight: "600",
                fontSize: "8px",
                width: "100%",
                boxSizing: "border-box"
              }}>
                {event.status}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SlickHorizontalTimeline;